import { client } from './client'

export default {
  issueToken (data) {
    return client.post('/token', {
      grant_type: 'password',
      client_id: process.env.CLIENT_ID,
      client_secret: process.env.CLIENT_SECRET,
      username: data.username,
      password: data.password,
      scope: ''
    })
  },
  refreshToken (data) {
    return client.post('/token', {
      grant_type: 'refresh_token',
      client_id: process.env.CLIENT_ID,
      client_secret: process.env.CLIENT_SECRET,
      refresh_token: data.refresh_token,
      scope: ''
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/auth.js